import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { CookieIcon } from 'lucide-react';
import { CookieSettings } from './CookieSettings';
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('vitafrukt-cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAcceptAll = () => {
    const prefs = {
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: Date.now()
    };
    localStorage.setItem('vitafrukt-cookie-consent', JSON.stringify(prefs));
    setIsVisible(false);
  };
  const handleNecessaryOnly = () => {
    const prefs = {
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: Date.now()
    };
    localStorage.setItem('vitafrukt-cookie-consent', JSON.stringify(prefs));
    setIsVisible(false);
  };
  const handleSettingsSave = (preferences: {
    necessary: boolean;
    analytics: boolean;
    marketing: boolean;
  }) => {
    const prefs = {
      ...preferences,
      timestamp: Date.now()
    };
    localStorage.setItem('vitafrukt-cookie-consent', JSON.stringify(prefs));
    setShowSettings(false);
    setIsVisible(false);
  };
  return <>
      <AnimatePresence data-id="element-82">
        {isVisible && !showSettings && <>
            {/* Subtle backdrop on mobile */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/10 z-40 md:hidden" aria-hidden="true" data-id="element-83" />

            {/* Banner */}
            <motion.div initial={{
          opacity: 0,
          y: 60
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 60
        }} transition={{
          duration: 0.4,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="fixed bottom-0 left-0 right-0 z-40 p-4 md:p-6" role="dialog" aria-label="Cookie-Hinweis" data-id="element-84">
              <div className="max-w-2xl mx-auto bg-white rounded-softer shadow-vita-hover border border-vita-border p-5 md:p-6" data-id="element-85">
                <div className="flex items-start gap-4" data-id="element-86">
                  <div className="w-10 h-10 rounded-full bg-vita-orange-pale flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-87">
                    <CookieIcon className="w-5 h-5 text-vita-orange" data-id="element-88" />
                  </div>
                  <div className="flex-grow min-w-0" data-id="element-89">
                    <p className="text-vita-text text-sm leading-relaxed mb-4" data-id="element-90">
                      Wir verwenden Cookies, um dir die bestmögliche Erfahrung
                      zu bieten.{' '}
                      <Link to="/datenschutz" className="text-vita-green-deep underline underline-offset-2 hover:text-vita-green-medium transition-colors" onClick={() => setIsVisible(false)} data-id="element-91">
                        Mehr erfahren
                      </Link>
                    </p>

                    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3" data-id="element-92">
                      <button onClick={handleAcceptAll} className="px-5 py-2.5 bg-vita-green-deep text-white font-medium rounded-full hover:bg-vita-green-medium transition-colors text-sm whitespace-nowrap" data-id="element-93">
                        Alle akzeptieren
                      </button>
                      <button onClick={handleNecessaryOnly} className="px-5 py-2.5 bg-white text-vita-text font-medium rounded-full border border-vita-border hover:border-vita-green-sage transition-colors text-sm whitespace-nowrap" data-id="element-94">
                        Nur notwendige
                      </button>
                      <button onClick={() => setShowSettings(true)} className="px-3 py-2.5 text-vita-text-muted hover:text-vita-green-deep text-sm underline underline-offset-2 transition-colors whitespace-nowrap" data-id="element-95">
                        Einstellungen
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>

      <CookieSettings isOpen={showSettings} onClose={() => setShowSettings(false)} onSave={handleSettingsSave} data-id="element-96" />
    </>;
}